import { Box, Button, Grid, Typography, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import timePassing from '@assets/images/time_passing.png';
import ReDialog from '@components/ReDialog';
import { useTranslation } from 'react-i18next';
import { useStoreAppColor } from '@state/useStoreAppColor';
import theme from '@styles/theme';
import useRxdbMiniappReq from '@hooks/useRxdbMiniappReq';
import { useMiniappReq } from '@state/useMiniappReq';

const useStyles = makeStyles({
  cover: {
    display: 'flex',
    height: '100%',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textWaitMoment: {
    textAlign: 'center',
    marginTop: '16px !important',
  },
  rotatingImage: {
    animation: '$rotation 2s infinite linear',
    width: 50,
  },
  '@keyframes rotation': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(359deg)',
    },
  },
});

const OvoPaymentModal = ({ open, onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { appColor } = useStoreAppColor((state) => ({
    appColor: state.appColor,
  }));
   const { getMiniappReqXendit, updateMiniappReqXendit } = useMiniappReq((state) => ({
      getMiniappReqXendit: state.getMiniappReqXendit,
      updateMiniappReqXendit: state.updateMiniappReqXendit,
    }));
  const [, , subscribeMiniappRequestXendit] = useRxdbMiniappReq();
  const [isLoading, setIsLoading] = useState(true);
  const [showCloseButton, setShowCloseButton] = useState(false);

  // tambahkan subscribe miniapp request id
  // lister key, partition, trans id, meta "xendit"
  useEffect(() => {
    if (open) {
      setIsLoading(true);
      setShowCloseButton(false);
      // Reset Xendit status when modal opens
      updateMiniappReqXendit(null);
      subscribeMiniappRequestXendit();
    }
    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    console.log('------------ xendit', getMiniappReqXendit())
    const xenditStatus = getMiniappReqXendit();

    if (xenditStatus === 'success') {
      // Payment success - auto close modal
      setIsLoading(false);
      onClose();
    } else if (xenditStatus === 'timeout') {
      // Timeout after 20 seconds - show close button but keep loading
      setShowCloseButton(true);
    }
    // eslint-disable-next-line
  }, [getMiniappReqXendit()]);
  return (
    <ReDialog
      open={open}
      closeModal={onClose}
      title="OVO Payment"
      content={
        <Box className={classes.cover}>
          <Grid
            direction="column"
            sx={{
              textAlign: 'center',
              paddingTop: theme.spacing(3),
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            {isLoading && (
              <>
                <CircularProgress sx={{ color: appColor.primaryThemeColor }} />
                <Typography
                  className={classes.textWaitMoment}
                  style={{ color: appColor.primaryFontColor }}>
                  {t('notifOvo')}
                </Typography>
              </>
            )}
          </Grid>
          {showCloseButton && (
            <Grid item sx={{ width: '100%', marginTop: theme.spacing(2) }}>
              <Button
                sx={{
                  color: appColor.secondaryFontColor,
                  backgroundColor: appColor.primaryThemeColor,
                  height: 'auto',
                  width: '100%',
                  '&:hover': {
                    backgroundColor: appColor.primaryThemeColor,
                  },
                }}
                onClick={onClose}
                variant="contained">
                Close
              </Button>
            </Grid>
          )}
        </Box>
      }
    />
  );
};
export default OvoPaymentModal;
